/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import { AqiICon } from './aqiIcon';
import { IconColors } from './iconConstants';

interface AirQualityIconProps {
    backgroundFillColor?: string;
    backgroundFillOpacity?: number;
    backgroundCircleWidth?: number;
    backgroundCircleHeight?: number;
    symbolFillColor?: string;
    symbolFillOpacity?: number;
    svgWidth?: number;
    svgHeight?: number;
}

export const AirQualityIcon = memo(({ 
    backgroundFillColor = IconColors.BackgroundFillColor,
    backgroundFillOpacity = IconColors.BackgroundFillOpacity,
    symbolFillColor = IconColors.SymbolFillColor,
    symbolFillOpacity = IconColors.SymbolFillOpacity,
    backgroundCircleWidth,
    backgroundCircleHeight,
    svgWidth,
    svgHeight
}: AirQualityIconProps) => {
    return (
        <Container 
            backgroundFillColor={backgroundFillColor} 
            backgroundFillOpacity={backgroundFillOpacity}
            backgroundCircleHeight={backgroundCircleHeight} 
            backgroundCircleWidth={backgroundCircleWidth} >
            <AqiICon 
                symbolFillColor={symbolFillColor}
                symbolFillOpacity={symbolFillOpacity}
                width={svgWidth}
                height={svgHeight}
            />
        </Container>
    );
});

AirQualityIcon.displayName = 'AirQualityIcon';

const Container = styled.div<AirQualityIconProps>`
    height: ${({ backgroundCircleHeight }) => backgroundCircleHeight ? `${backgroundCircleHeight}px` : '60px'};
    width: ${({ backgroundCircleWidth }) => backgroundCircleWidth ? `${backgroundCircleWidth}px` : '60px'};
    border-radius: 100%;

    ${({ backgroundFillColor }) =>  backgroundFillColor && `
        background-color: ${backgroundFillColor};
    `}
`;
